import React, { useEffect, useRef } from 'react';
import Float from './Float';
import Label from './Label';
import Button from './Button';
import ModalButton from './ModalButton';

const Modal = (props) => {

    const { className = "", alert = false, mask_close = false, align = "top", refElement = false, closable = false, title = "", callback = () => { }, component, offset = [0, 0] } = props;

    // const modalRef = useRef(null);

    let _classname = "ui-modal";

    if (className) {
        _classname += " " + className;
    }

    const handleClick = (e) => {

       
        if (e.target.getAttribute("data-mask-click") === "true") {
            callback(false);
        }
    }

    if (refElement || alert) {





        let style = {}

        if (refElement) {
            const { bottom, left, top } = refElement.getBoundingClientRect();
            style.position = 'absolute';
            style.left = `${(left + offset[1]) + window.scrollX}px`;

            if (align === "bottom") {
                style.bottom = `${window.innerHeight - top + offset[0] - window.scrollY}px`;
            } else {
                style.top = `${(bottom + offset[0]) + window.scrollY}px`;
                
            }
        }



        return (
            <div data-bg="bg" className={_classname} style={{ "alignItems": "center" }}>
               
                <div data-mask-click={mask_close} onClick={(e) => handleClick(e)} className="ui-modal-overlay" style={{ "alignItems": "center" }}>
                    <div style={style} >{React.cloneElement(component, { callback: callback })}</div>
                </div>
            </div>
        );
    }


    return (
        <div className="ui-modal" style={{ "alignItems": "center" }}>
            <div data-mask-click={mask_close} onClick={(e) => handleClick(e)} className="ui-modal-overlay" style={{ "alignItems": "center" }}>
                <div
                    className="ui-modal-content"
                // ref={modalRef}
                // tabIndex={-1} // Allows the element to be focused
                >
                    <div className="ui-modal-header">
                        <div style={{ "padding": "0px 10px", "paddingBottom": "5px", "width": "100%" }}>
                            <Float>
                                <Label>{title}</Label>
                                {(closable && <ModalButton onClick={() => callback()} style={{ "marginTop": "-2px" }} value={<>&times;</>} />)}
                            </Float>
                        </div>
                    </div>
                    <div className="ui-modal-body">{React.cloneElement(component, { callback: callback })}</div>
                </div>
            </div>
        </div>
    );
};

export default Modal;
